import { useEffect } from 'react';

import { getUserSearch } from '@web-platform/shared-universal-redux/src/state';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

export const useInitialiseHistoryState = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userSearch = useSelector(getUserSearch);

  // Sync browser history state with searchParams
  useEffect(() => {
    const newLocationState = {
      ...location.state,
      searchParams: userSearch,
    };
    navigate(location, { replace: true, state: newLocationState });
    // We only want to do this once on initial load
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
